import './App.css';
import Home from './screens/home';
import Config from "./config.json"
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const CLIENT_NAME = Config.CLIENT_NAME;
function App() {
  document.title = 'Health Check';
  const theme = localStorage.getItem('theme') || 'dark';
  document.documentElement.classList.toggle('dark', theme === 'dark');
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route>
            <Route index element={<Home />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <div>
        <ToastContainer theme={theme === 'dark' ? 'dark' : 'light'} />
      </div>
    </div >

  );
}

export default App;
